import React from "react"
import { TechnicianDto } from "../../generated"

export default (props: { allTechnicians: TechnicianDto[] }) => {
    const { allTechnicians } = props;
    const input = React.useRef<HTMLInputElement>(null);
    return <div className='p-3'>
        <div className='fw-bold p-1'>
            <div className="mb-2">Sincronizza automaticamente gli interventi di Caldaie Manager con Google Calendar / iOS / Android / Outlook e tutte le piattaforme che supportano il formato ICal.</div>
            <div className="mb-3">Copia il link del calendario sul dispositivo\account di ogni tecnico per sincronizzare i suoi interventi pianificati.</div>
        </div>
        {allTechnicians.map(x => (<div className='input-group mb-4'>
            <span className='input-group-text bg-theme text-white'>{x.firstName} {x.lastName}</span>
            <input ref={input} className='form-control flex-fill' type="text" readOnly value={x.calendarLink} />
            <button className='btn btn-outline-secondary' onClick={() => {
                const innerHtml = input!.current!.value;
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(innerHtml);
                }
            }}><i className='far fa-copy fa-lg me-2' />Copia Link</button>
        </div>))}
        <div className='d-flex w-100 flex-wrap'>
            <div className='d-flex align-items-center me-5 text-nowrap'>
                <i className="fab fa-android fa-2x me-2" />
                <a href="https://support.google.com/calendar/answer/37100?co=GENIE.Platform%3DAndroid&hl=it&oco=1#add_via_link" >Guida configurazione Google Calendar, Android</a>
            </div>
            <div className='d-flex align-items-center text-nowrap'>
                <i className="fab fa-apple fa-2x me-2" />
                <a href="https://support.apple.com/it-it/HT202361" > Guida configurazione Ios Apple Iphone</a>
            </div>
        </div>
    </div>
}

